import { NextImage } from "@jog/react-components"
import { memo } from "react"

function LogoLoaderFC() {
    return (
        <div className="fixed inset-0 z-10 flex items-center justify-center bg-black/70">
            <NextImage blur={false} src="/images/garcia-loader.gif" alt="loader" width="64" height="64" />
        </div>
    )
}

export const LogoLoader = memo(LogoLoaderFC)
